import React from "react";
import { Spin } from "antd";

const SpinLoader = () => {
  return (
    <>
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{
          zIndex: 2050,
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
        }}
      >
        {/* <SpinLoader /> */}
        <Spin size="large" tip="Processing..." />
      </div>
    </>
  );
};

export default SpinLoader;
